(function ($) {
    "use strict";
    $(function () {
        (function (factory) {
            if (typeof define === "function" && define.amd) {
                define(["jquery", "moment", "datatables.net"], factory);
            } else {
                factory(jQuery, moment);
            }
        }(function ($, moment) {
            $.fn.dataTable.moment = function (format, locale) {
                var types = $.fn.dataTable.ext.type;
                types.detect.unshift(function (d) {
                    if (d) {
                        if (d.replace) {
                            d = d.replace(/(<.*?>)|(\r?\n|\r)/g, '');
                        }

                        d = $.trim(d);
                    }

                    // Null and empty values are acceptable
                    if (d === '' || d === null || 'Not set') {
                        return 'moment-' + format;
                    }

                    return moment(d, format, locale, true).isValid() ?
                        'moment-' + format :
                        null;
                });

                types.order['moment-' + format + '-pre'] = function (d) {
                    if (d) {
                        if (d.replace) {
                            d = d.replace(/(<.*?>)|(\r?\n|\r)/g, '');
                        }

                        d = $.trim(d);
                    }

                    return !moment(d, format, locale, true).isValid() ?
                        Infinity :
                        parseInt(moment(d, format, locale, true).format('x'), 10);
                };
            };
        }));

        // Equivalent of Carbon's ->toDayDateTimeString()
        $.fn.dataTable.moment('ddd, MMM D, YYYY h:mm A');

        $("#data-table").DataTable({
            aLengthMenu: [[5, 10, 15, -1], [5, 10, 15, "All"]],
            iDisplayLength: 10,
            language: { search: "" },
            order: []
        });
        $("#data-table").each(function () {
            var datatable = $(this);

            datatable
                .closest(".dataTables_wrapper")
                .find("div[id$=_filter] input")
                .attr("placeholder", "Search")
                .removeClass("form-control-sm");
                
            datatable
                .closest(".dataTables_wrapper")
                .find("div[id$=_length] select")
                .removeClass("form-control-sm");
        });
    });
})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/datatables.js